export default {
    ACTIVE_CLASS_MONEY_MARKET_ID: 'AC001',
    ACTIVE_CLASS_FIXED_INCOME_ID: 'AC002',
    ACTIVE_CLASS_EQUITY_ID: 'AC003',
    ACTIVE_CLASS_REAL_ASSETS_ID: 'AC004',
    CARD_ONE: 1,
    CARD_TWO: 2,
    CARD_THREE: 3,
    CARD_FOUR: 4,
    CARD_FIVE: 5,
    CONTRIBUTION_ISBAN_CODE_DAILY: '101',
    CONTRIBUTION_ISBAN_CODE_MONTHLY: '201',
    CONTRIBUTION_ISBAN_CODE_WEEKLY: '107',
    CONTRIBUTION_ISBAN_CODE_YEARLY: '301',
    CONTRIBUTION_PERIOD_DAILY: 365,
    CONTRIBUTION_PERIOD_MONTHLY: 12,
    CONTRIBUTION_PERIOD_PUNCTUAL: 1,
    CONTRIBUTION_PERIOD_WEEKLY: 52,
    MINIMUM_PERIODIC_CONTRIBUTION: 1,
    DATE_FORMAT: 'D MMM YYYY',
    DATE_FORMAT_DAY_MONTH: 'D MMM',
    DATE_FORMAT_MONTH_YEAR: 'MMM YYYY',
    DATE_FORMAT_TIME_HORIZON_CHECK: 'YYYY-MM-DD',
    DATE_FORMAT_YEAR: 'YYYY',
    EURO_SYMBOL: '€',
    EURO_TEXT: 'EUR',
    INCOMINGS: 'incomings',
    INCOMING_OUTGOING_MAX: 9999999.99,
    MONTHS: 'MONTHS',
    OUTGOINGS: 'outgoings',
    PERCENTAGE_SYMBOL: '%',
    RA_INVESTMENT_HORIZON_INPUT_MIN: 1,
    RA_INVESTMENT_HORIZON_INPUT_MAX: 99,
    RA_INVESTMENT_HORIZON_MAX_NON_MASKED_INPUT_VALUE: 25,
    RA_INVESTMENT_HORIZON_SLIDER_MAX: 26,
    RA_INVESTMENT_HORIZON_SLIDER_MIN: 1,
    RA_PROJECTION_CHART_ALL_PRODUCTS: 0,
    SUITABILITY_TEST_STEP_TO_ANSWERS: {
        0: '101',
        1: '102',
        2: '103',
        3: '104',
        5: '218',
        6: '219',
    },
    SUITABILITY_TEST_INVESTMENT_ANSWERS: ['106', '107', '108', '109', '110', '111', '112', '113', '114', '115'],
    SUITABILITY_TEST_PROFILE_MODEL_ANSWERS: 'userProfile.RASuitabilityTest.answers',
    SUITABILITY_TEST_STEP_1: 0,
    SUITABILITY_TEST_STEP_2: 1,
    SUITABILITY_TEST_STEP_3: 2,
    SUITABILITY_TEST_STEP_4: 3,
    SUITABILITY_TEST_STEP_5: 4,
    SUITABILITY_TEST_STEP_6: 5,
    SUITABILITY_TEST_STEP_7: 6,
    SUITABILITY_TEST_STEP_8: 7,
    SUITABILITY_TEST_STEP_9: 8,
    SUITABILITY_TEST_STEP_10: 9,
    SUITABILITY_TEST_NO_TEST: 1,
    SUITABILITY_TEST_VALID: 2,
    SUITABILITY_TEST_EXPIRED: 3,
    SUITABILITY_TEST_UNSIGNED: 4,
    SUITABILITY_TEST_IN_PROGRESS: 5,
    SUITABILITY_TEST_REDO: 6,
    MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT: 500,
    SUITABILITY_TEST_ALL_PRODUCTS: 0,
    TIME_HORIZON_CHECK_ERROR: 'TIME_HORIZON_CHECK_ERROR',
    TIME_HORIZON_CHECK_NOT_PERFORMED: 'TIME_HORIZON_CHECK_NOT_PERFORMED',
    TIME_HORIZON_CHECK_VALID: 'TIME_HORIZON_CHECK_VALID',
    TIME_HORIZON_CHECK_WARNING: 'TIME_HORIZON_CHECK_WARNING',
    DISABLED_PROBABILITY: 'DISABLED',
    HIGH_PROBABILITY: 'HIGH',
    MEDIUM_PROBABILITY: 'MEDIUM',
    LOW_PROBABILITY: 'LOW',
    NONE_PROBABILITY: 'NONE',
    RA_PROJECTION_CHART_UP_KEY: 'up',
    RA_PROJECTION_CHART_MID_KEY: 'mid',
    RA_PROJECTION_CHART_LOW_KEY: 'low',
    MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT: 9999999.99,
    FULL_MONTH_DAYS: 31,
    MAXIMUM_PERIODIC_CONTRIBUTION: 5000,
    SECONDARY_BAR_COLOR: '#E3E9E9',
    INVESTMENT_PROCESS_PDF: '/assets/static/pdf/Nuestro_proceso_de_inversion.pdf',
    RA_POTFOLIO_COMPOSITION_TABLE_DECIMAL_LENGTH: 2,
    MINIMUM_OBJECTIVE_AMOUNT: 500,
    FIRST_STEP: 0,
    SECOND_STEP: 1,
    RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT: 99999999,
    RA_SET_GOAL_MINIMUM_INVESTMENT_AMOUNT: 500,
    RA_DATEPICKER_MAXIMUM_YEARS: '25',
    MINIMUM_CONTRIBUTION_AMOUNT: 1,
    INVEST_PROFILE: {
        1: 'Kuala Lumpur',
        2: 'Shangai',
        3: 'Taipei',
        4: 'New York',
        5: 'Dubai',
    },
    BUILDING_HEIGHTS: {
        1: '374 mt',
        2: '456 mt',
        3: '509 mt',
        4: '543 mt',
        5: '826 mt',
    },
    SUSTAINABILITY_LEVEL: {
        NEUTRAL: 'neutral',
        INTERMEDIATE: 'intermediate',
        ADVANCED: 'advanced',
    },
};
